<template>
  <div class="TeamPage content inner-grid-container">
    <div class="banner">
      <Banner class="fancyHeading" v-bind:text="team.name"></Banner>
    </div>
    <div class="add-player">
      <AddPlayers v-bind:team="team"></AddPlayers>
    </div>
    <div class="team-stats">
      <div class="addText">AVERAGE TEAM STATS</div>
      <TeamStatsCard v-bind:team="team"></TeamStatsCard>
    </div>
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue'
import AddPlayers from '@/components/AddPlayers.vue'
import TeamStatsCard from '@/components/TeamStatsCard.vue'
export default {
  name: 'TeamPage',

  components: {
    Banner,
    AddPlayers,
    TeamStatsCard
  },

  computed: {
    team(){
      return this.$store.state.teams[this.$store.getters.teamIndex(this.$route.params.teamId)];
    }
  },

  methods: {
  }
}
</script>

<style scoped>
.inner-grid-container {
    display: grid;
    grid-column-gap: 30px;
    grid-template-columns:auto 500px 500px auto;
    grid-template-areas:
        'banner banner banner banner'
        'leftleft left right rightright';
    grid-row-gap: 25px;
}

.add-player{
  grid-area: right;
}

.team-stats{
    grid-area: left;
}

@media (max-width: 600px){
.inner-grid-container{
  grid-template-columns:auto auto auto auto;
  grid-column-gap: 0;
  grid-template-areas:
      'banner'
      'right'
      'left' 
      'leftleft' 
      'rightright';
  }

}
</style>



// WEBPACK FOOTER //
// src/components/TeamPage.vue